
export default class {
    constructor() {
        this.setEvents();
    }

    setEvents() {
        var img = $('.contactblock-label').find('img');
        $('.contactblock-label').on('click', function(e) {
            var block = $('.contactblock');
            if (block.is(':visible')) {
                block.slideUp();
                img.removeClass('rotate180');
                $(this).attr('aria-expanded', 'false');
            } else {
                block.slideDown(350);
                img.addClass('rotate180');
                $(this).attr('aria-expanded', 'true');
            }
        });
    }
}